import { createContext } from 'react';

export const OrchestrationContext = createContext({
  onClickOrchestrate: (data) => {},
});
